import imb_portfolio_balance from "./../assets/images/portfolio-balance.png";
import imb_upcoming_payments from "./../assets/images/upcoming-payments.png";
import NumberFormat from "react-number-format";

const QuickInfoCardCommon = ({
  label,
  info,
  class_name,
  backgroundColor = "#ffffff",
}) => {
  return (
    <div id="QuickInfoCard" className={class_name}>
      <div
        style={{ backgroundColor: backgroundColor }}
        className="QuickInfoCard_Content px-3 h-100 rounded d-flex flex-column justify-content-center align-items-start"
      >
        <p className="pb-0 fs-6 mb-2 ps-3">
          {label === "Portfolio Balance" ||
          label === "Total No. of Loans" ||
          label === "Active Loan Portfolio Balance" ||
          label === "Default Portfolio Balance" ||
          label === "Total No. of Defaults" ? (
            <>
              <img
                style={{ width: "75px", paddingRight: "10px" }}
                src={imb_portfolio_balance}
                alt=""
              />
            </>
          ) : label === "Upcoming Payments" ||
            label === "Outstanding Charges" ? (
            <>
              <img
                style={{ width: "75px", paddingRight: "10px" }}
                src={imb_upcoming_payments}
                alt=""
              />
            </>
          ) : (
            <></>
          )}
          {label}
        </p>
        <p className="pt-0 mb-0 fs-4 ps-3" style={{ color: "#555" }}>
          <strong>
            {label === "Portfolio Balance" ||
            label === "Default Portfolio Balance" ? (
              <NumberFormat
                displayType="text"
                value={info}
                prefix={"$"}
                fixedDecimalScale={true}
                decimalScale={2}
                thousandSeparator={true}
              />
            ) : label === "Active Loan Portfolio Balance" ? (
              <NumberFormat
                displayType="text"
                value={info}
                prefix={"$"}
                fixedDecimalScale={true}
                decimalScale={2}
                thousandSeparator={true}
              />
            ) : label === "Upcoming Payments" ? (
              <NumberFormat
                displayType="text"
                value={info}
                prefix={"$"}
                customInput={false}
                fixedDecimalScale={true}
                decimalScale={2}
                thousandSeparator={true}
              />
            ) : label === "Outstanding Charges" ? (
              <NumberFormat
                displayType="text"
                value={info}
                prefix={"$"}
                customInput={false}
                fixedDecimalScale={true}
                decimalScale={2}
                thousandSeparator={true}
              />
            ) : (
              info
            )}
          </strong>
        </p>
      </div>
      <style>
        {`
                .QuickInfoCard_Content{
                    height: 155px;
                }
                input{
                    border: none;
                }
                `}
      </style>
    </div>
  );
};
export default QuickInfoCardCommon;
